import { useState } from "react";

export default function ComparisonBlock({ aTitle, bTitle, aContent, bContent }) {
  const [side, setSide] = useState("a");

  return (
    <div className="space-y-4">
      <div className="flex gap-4">
        <button
          className={`px-3 py-1 rounded-full text-sm ${
            side === "a" ? "bg-black text-white" : "bg-black/10"
          }`}
          onClick={() => setSide("a")}
        >
          {aTitle}
        </button>

        <button
          className={`px-3 py-1 rounded-full text-sm ${
            side === "b" ? "bg-black text-white" : "bg-black/10"
          }`}
          onClick={() => setSide("b")}
        >
          {bTitle}
        </button>
      </div>

      <div className="p-6 rounded-3xl bg-white/30 dark:bg-white/5 backdrop-blur-xl border border-black/10 dark:border-white/10">
        {side === "a" ? aContent : bContent}
      </div>
    </div>
  );
}
